<template>
    <div class="home">
        <app-parallax title="test" />
    </div>
</template>

<script>
const loadComponent = (componentName) => {
    return () => import(`@/components/${componentName}`);
};

export default {
    components: {
        appParallax: loadComponent("parallax"),
    },
};
</script>
